import React, { useId } from 'react';

// Labelled form field: the label is bound to the control via htmlFor, the error / hint through aria-describedby.
// `children` is a render function receiving the props the control must spread: ({ id, ...aria }) => <input ... />
export const Field = ({ label, hint, error, required, className = '', children }) => {
  const id = useId();
  const errId = `${id}-err`;
  const hintId = `${id}-hint`;
  const describedBy = [error && errId, hint && hintId].filter(Boolean).join(' ') || undefined;
  return (
    <div className={`shp-field ${className}`}>
      <label htmlFor={id} className="shp-label">
        {label}{required && <span aria-hidden="true" style={{ color: '#E53935' }}> *</span>}
      </label>
      {children({ id, 'aria-describedby': describedBy, 'aria-invalid': error ? 'true' : undefined, 'aria-required': required || undefined })}
      {error ? <p id={errId} role="alert" className="shp-error">{error}</p> : hint ? <p id={hintId} className="shp-hint">{hint}</p> : null}
    </div>
  );
};

export const TextField = ({ label, hint, error, required, className, ...input }) => (
  <Field label={label} hint={hint} error={error} required={required} className={className}>
    {(aria) => <input className="shp-input" {...aria} {...input} />}
  </Field>
);

export const TextAreaField = ({ label, hint, error, required, className, ...input }) => (
  <Field label={label} hint={hint} error={error} required={required} className={className}>
    {(aria) => <textarea className="shp-textarea" {...aria} {...input} />}
  </Field>
);

// options: [{ value, label }]; `placeholder` adds an empty first option
export const SelectField = ({ label, hint, error, required, className, options, placeholder, ...select }) => (
  <Field label={label} hint={hint} error={error} required={required} className={className}>
    {(aria) => (
      <select className="shp-select" {...aria} {...select}>
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    )}
  </Field>
);
